export default "__VITE_ASSET__B8o$5NxW__"